import {Input} from 'reactstrap'

export const NumberInput = ({
  name,
  placeholder,
  readOnly,
  disabled,
  value,
  onChange,
  onBlur,
  ...remainingProps
}) => {
  return (
    <Input
      className="text-center"
      type="number"
      name={name}
      placeholder={placeholder}
      readOnly={readOnly}
      disabled={disabled}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      {...remainingProps}
    />
  )
}
